import React from 'react';

import styles from './sidebarViewsWidgetStyles';

import IdeaViewsList from 'buyside/components/presentation/IdeaViewsPage/IdeaViewsList/ideaViewsList';
import Link from 'buyside/components/presentation/Link/link';

import { contributorDashboardIdeasUrl } from 'buyside/util/urlHelper';

const SidebarViewsWidget = ({ data }) => {
  const newViewsCount = data.currentUser.publishedIdeas.edges.reduce(
    (acc, edge) => acc + edge.node.newViewsCount,
    0
  );
  const views = data.currentUser.lastNViews.edges.map(edge => edge.node);
  const noViewsText = 'Nobody has viewed your research yet. Check back soon!';
  return (
    <div className={styles.viewsContainer}>
      <h2 className={styles.viewsHeading}>
        Members Viewing Your Ideas
        {!!newViewsCount && (
          <span>
            <strong>{newViewsCount}</strong> New
          </span>
        )}
      </h2>
      {views.length ? (
        <IdeaViewsList views={views} showIntroRequest={false} isLink />
      ) : (
        <p className={styles.noViews}>{noViewsText}</p>
      )}
      {!!views.length && (
        <Link className={styles.viewsLink} to={contributorDashboardIdeasUrl()}>
          View More
        </Link>
      )}
    </div>
  );
};

export default SidebarViewsWidget;
